export type IcPaginationTypes = "simple" | "complex";
export type IcPaginationAlignmentOptions = "left" | "right" | "space-between";
export type IcPaginationLabelTypes = "page" | "data";
export interface IcChangeEventDetail {
  value: number;
}
